import { render, staticRenderFns } from "./users-multi-select.vue?vue&type=template&id=8450a71a&"
import script from "./users-multi-select.vue?vue&type=script&lang=js&"
export * from "./users-multi-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports